import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60813e7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-mb-4"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" The Segment Group is set to ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(". To change it please select from the groups below: ")
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "columns override tw-mt-4" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "tw-mb-4"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" The id of this upload will be ")
const _hoisted_9 = {
  key: 1,
  class: "tw-mb-2"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 0 }

import { UseSegementStore } from "../../../../Modules/State/Stores/SegmentStore";
import { storeToRefs } from "pinia";
import { UseUpload } from "../../../../Pages/SegmentManagement/Uploads/Hooks/UseUpload";
import BatchFixedFileUpload from "./FileUploadInput.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { getSegmentGroupData: allSegmentGroupData } = storeToRefs(UseSegementStore());
const {
  segmentGroup,
  file: uploadedFile,
  showError,
  uniqueSheetId,
  currentSheet,
  showUniqueIdField,
  getGroupTitle,
} = UseUpload();

return (_ctx: any,_cache: any) => {
  const _component_o_select = _resolveComponent("o-select")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_input = _resolveComponent("o-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(segmentGroup).length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("strong", null, _toDisplayString(_unref(getGroupTitle)(_unref(segmentGroup))), 1),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_o_select, {
      modelValue: _unref(segmentGroup),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(segmentGroup) ? (segmentGroup).value = $event : null)),
      "aria-role": "list",
      disabled: !_unref(allSegmentGroupData).length
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allSegmentGroupData), (name, i) => {
          return (_openBlock(), _createElementBlock("option", {
            key: i,
            value: name.group_name,
            "aria-role": "listitem"
          }, _toDisplayString(name.group_title), 9, _hoisted_4))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "disabled"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(BatchFixedFileUpload, {
        file: _unref(uploadedFile),
        "onUpdate:file": _cache[1] || (_cache[1] = ($event: any) => (_isRef(uploadedFile) ? (uploadedFile).value = $event : null))
      }, null, 8, ["file"])
    ]),
    (_unref(uploadedFile))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (!_unref(showError))
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("strong", null, _toDisplayString(_unref(uniqueSheetId)), 1)
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_9, "This ID has already been taken. Please change it below")),
          (_unref(showError))
            ? (_openBlock(), _createBlock(_component_o_field, { key: 2 }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    type: "button",
                    class: "button is-primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (showUniqueIdField.value = !_unref(showUniqueIdField)))
                  }, " Change upload ID ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(showUniqueIdField))
            ? (_openBlock(), _createBlock(_component_o_field, {
                key: 3,
                class: "radio-field-input"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_o_input, {
                    lazy: "",
                    placeholder: _unref(uniqueSheetId),
                    modelValue: _unref(uniqueSheetId),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(uniqueSheetId) ? (uniqueSheetId).value = $event : null))
                  }, null, 8, ["placeholder", "modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_unref(currentSheet))
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, "The id of this sheet will be " + _toDisplayString(_unref(currentSheet)), 1))
            : _createCommentVNode("", true)
        ]))
  ], 64))
}
}

})